import { render, staticRenderFns } from "./ShMasterMenu.vue?vue&type=template&id=2a2dbaee&scoped=true&"
import script from "./ShMasterMenu.vue?vue&type=script&lang=js&"
export * from "./ShMasterMenu.vue?vue&type=script&lang=js&"
import style0 from "./ShMasterMenu.vue?vue&type=style&index=0&id=2a2dbaee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2dbaee",
  null
  
)

export default component.exports